module.exports = __webpack_public_path__ + "docs/img/cloud.c34573d7.png";